import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NotificationChannel = DatabaseCode

const email: NotificationChannel = {
  code: 'EMAIL',
  displayValue: {
    id: 'common.entity.notification.channel.email',
    defaultMessage: 'Email',
  },
};

const push: NotificationChannel = {
  code: 'PUSH',
  displayValue: {
    id: 'common.entity.notification.channel.push',
    defaultMessage: 'Push',
  },
};

const sms: NotificationChannel = {
  code: 'SMS',
  displayValue: {
    id: 'common.entity.notification.channel.sms',
    defaultMessage: 'SMS',
  },
};

export const notificationChannel = {
  email,
  push,
  sms
};

export const notificationChannels = Object.values(notificationChannel);

export const toNotificationChannel = (code: string): NotificationChannel => toDatabaseCode(code, notificationChannels);
export const toNotificationChannelSafely = (code: string | undefined): NotificationChannel | undefined => code ? toDatabaseCode(code, notificationChannels) : undefined;

export const toNotificationChannels = (code: string[]): NotificationChannel[] => code.map(toNotificationChannel);
